import styled, { keyframes } from 'styled-components';
import { TextMedium } from '../../styles/GlobalStyledComponents';

const transitionAnimation = keyframes`
  0% {
    transform: translate(-5px, 5px);    
  }
  100% {
    transform: translate(10px, -10px);
  }
`;

export const MainContainer = styled.div`
  flex-direction: column;
  box-sizing: border-box;
  display: flex;
  place-content: flex-start;
  align-items: center;
  background-color: white;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 1;
  padding-left: 2.5rem;
  padding-right: 2.5rem;
  justify-content: flex-start;
  padding-top: 100px;
  /* margin-top: 50px; */

  @media (max-width: 500px) {
    padding-top: 0;
  }

  @media (max-width: 400px) {
    padding-left: 1rem;
    padding-right: 1rem;
  }
`;

export const TransitionText = styled(TextMedium)`
  margin-top: 30px;
  line-height: 24px;
  white-space: pre-line;
  text-align: center;
`;

export const ImageContainer = styled.div`
  margin-top: 70px;
  width: 100%;
  position: relative;
`;

export const ImageLine = styled.div`
  position: absolute;
  top: 0px;
  left: 25px;
  animation-name: ${transitionAnimation};
  animation-duration: 2.5s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  z-index: 10;
  width: 80%;

  & > svg {
    display: block;
    width: 100%;
    height: auto;
  }
`;

export const ImageBackground = styled.div`
  position: absolute;
  top: 10px;
  left: 20%;
  width: 65%;
  max-width: 65%;

  & > svg {
    display: block;
    width: 100%;
    height: auto;
  }
`;
